<div class="loader" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
</div>

<div class="modal-header">
    <mat-icon class="clickable text-transparent">&nbsp;&nbsp;&nbsp;&nbsp;</mat-icon>
    <h4 class="modal-title">Edit Job</h4>
    <mat-icon class="close clickable me-4" (click)="onClose()">close</mat-icon>
</div>

<form class="" [formGroup]="jobForm" (ngSubmit)="onSubmit()">
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-6">
                <label class="form-label">Name</label>
                <input type="text" class="form-control" formControlName="name"
                    [id]="jobForm.controls.name.errors && jobForm.controls.name.touched?'invalidField':''">
            </div>
            <div class="col-md-6">
                <label class="form-label">Description (Optional)</label>
                <input type="text" class="form-control" formControlName="description"
                    [id]="jobForm.controls.description.errors && jobForm.controls.description.touched?'invalidField':''">
            </div>
        </div>
        <div class="row g-3">
            <div class="col-md-6">
                <label class="form-label">Location (Optional)</label>
                <input type="text" class="form-control" formControlName="location"
                    [id]="jobForm.controls.location.errors && jobForm.controls.location.touched?'invalidField':''">
            </div>
            <div class="col-md-6">
                <label class="form-label">Positions (Optional)</label>
                <input type="number" class="form-control" formControlName="positions"
                    [id]="jobForm.controls.positions.errors && jobForm.controls.positions.touched?'invalidField':''">
            </div>
        </div>
        <div class="accordion mt-5">
            <!-- Client & Timesheet Approvers-->
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button d-flex justify-content-between" type="button"
                        (click)="toggleSection('clienAndTimesheetApprovers')"
                        [class.collapsed]="collapsedSections['clienAndTimesheetApprovers']">
                        <b>Client & Timesheet Approvers (Required)</b>
                    </button>
                </h2>
                <div [ngClass]="{'collapse': collapsedSections['clienAndTimesheetApprovers'], 'show': !collapsedSections['clienAndTimesheetApprovers']}"
                    id="clienAndTimesheetApprovers">
                    <div class="accordion-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label">Client</label>
                                <input type="text" class="form-control" formControlName="client" readonly />
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Timesheet Approvers</label>
                                <mat-select class="me-2 input-form" type="text" multiple
                                    formControlName="timesheet_approvers"
                                    [(ngModel)]="selectedTimesheetApprovers">
                                    <mat-option
                                        *ngFor="let timesheetApprover of timesheetApprovers; let i = index;"
                                        [value]="timesheetApprover.uuid">
                                        {{timesheetApprover.name}}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Assign Contractor-->
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button d-flex justify-content-between" type="button"
                        (click)="toggleSection('assignContractor')"
                        [class.collapsed]="collapsedSections['assignContractor']">
                        <b>Assign Contractor (Required)</b>
                    </button>
                </h2>
                <div [ngClass]="{'collapse': collapsedSections['assignContractor'], 'show': !collapsedSections['assignContractor']}"
                    id="assignContractor">
                    <div class="accordion-body">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label">Candidate</label>
                                <input type="text" class="form-control" formControlName="candidates" readonly />
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">PO Number</label>
                                <input type="text" class="form-control" formControlName="po_number"
                                    [id]="jobForm.controls.po_number.errors && jobForm.controls.po_number.touched?'invalidField':''">
                            </div>
                        </div>
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label">Select Onboarding Form</label>
                                <input type="text" class="form-control" formControlName="on_boarding_form" readonly />
                            </div>
                            <div class="col-md-6">
                                <label class="form-label">Start Date - End Date</label>
                                <div class="datePickerRangeContainer" (click)="picker.open()"
                                    [id]="(jobForm.controls.start_date.errors && jobForm.controls.start_date.touched?'invalidField':'') || (jobForm.controls.end_date.errors && jobForm.controls.end_date.touched?'invalidField':'')">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker color="primary"></mat-date-range-picker>
                                    <i class="bi bi-calendar4"></i>
                                    <mat-date-range-input [rangePicker]="picker">
                                        <input matStartDate formControlName="start_date">
                                        <input matEndDate formControlName="end_date">
                                    </mat-date-range-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Job Rates Section -->
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button d-flex justify-content-between" type="button"
                        (click)="toggleSection('jobRates')" [class.collapsed]="collapsedSections['jobRates']">
                        <b>Rates & Costing (Required)</b>
                    </button>
                </h2>
                <div [ngClass]="{'collapse': collapsedSections['jobRates'], 'show': !collapsedSections['jobRates']}"
                    id="jobRates">
                    <div *ngIf="ratesArray.controls.length">
                        <div class="accordion-body" formArrayName="rates">
                            <div class="row g-3" *ngFor="let fg of ratesArray.controls; let i = index"
                                [formGroupName]="i">

                                <div class="col-md-6">
                                    <label class="form-label">{{ jobRates[i]?.name }} Pay Rate</label>
                                    <input type="number" class="form-control"
                                        placeholder="Enter {{ jobRates[i]?.name }} Pay Rate" formControlName="pay_rate">
                                </div>

                                <div class="col-md-6">
                                    <label class="form-label">{{ jobRates[i]?.name }} Bill Rate</label>
                                    <input type="number" class="form-control"
                                        placeholder="Enter {{ jobRates[i]?.name }} Bill Rate"
                                        formControlName="bill_rate">
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- Contract Section -->
            <div class="accordion-item" *ngIf="job.status !== 5">
                <h2 class="accordion-header">
                    <button class="accordion-button d-flex justify-content-between" type="button"
                        (click)="toggleSection('contract')" [class.collapsed]="collapsedSections['contract']">
                        <b>Contract (Optional)</b>
                    </button>
                </h2>
                <div [ngClass]="{'collapse': collapsedSections['contract'], 'show': !collapsedSections['contract']}"
                    id="contract">
                    <div class="accordion-body">
                        <div class="row g-3">
                            <div class="col-md-12 d-flex align-items-center">
                                <ng-container *ngIf="sendContract; else elseBlock">
                                    <input type="checkbox" class="custom-checkbox" formControlName="is_checked"
                                        [checked]="sendContract" [attr.disabled]="sendContract">
                                </ng-container>
                                <ng-template #elseBlock>
                                    <input type="checkbox" class="custom-checkbox" formControlName="is_checked"
                                        [checked]="job.contract !== null"
                                        [attr.disabled]="job.contract !== null ? true : null">
                                </ng-template>
                                <label class="form-label ms-2 mb-0"> Add Contract</label>
                            </div>
                            <div *ngIf="job.contract == null && jobForm.get('is_checked').value" class="col-md-12">
                                <input type="file" class="form-control" [accept]="acceptFiles.join(',')"
                                    formControlName="contract_file" (change)="onFileSelected($event)"
                                    [id]="jobForm.controls.contract_file.errors && jobForm.controls.contract_file.touched?'invalidField':''">
                            </div>
                            <div *ngIf="job.contract && job.contract.is_separate_contract" class="col-md-12">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <div class="box">
                                            <img class="imageIcon" *ngIf="getFileIcon(job.contract.name)"
                                                [src]="getFileIcon(job.contract.name)" />
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="textarea">
                                            <div class="nameText mt-4">
                                                <label>{{ job.contract.name }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="error" *ngIf="error">
            <span>{{error}}</span>
        </div>
        <button type="submit" class="btn btn-sm mx-2 btn-primary" [disabled]="isSaveDisabled()">Save</button>
    </div>
</form>
